import * as React from 'react';
var HoverContext = /*#__PURE__*/React.createContext({});
export default HoverContext;